<template>
  <div>
    <v-col cols="11" sm="12" md="12">
      <v-dialog v-model="dialog" width="500px" height="500px">
        <v-col cols="12" sm="12" md="12">
          <v-row justify="center" align="center">
            <div align="center" class="container">
              <h2>Email has been sent to</h2>
              <h3 align="center" style="color: #00d200">{{ email }}</h3>
              <p align="center" style="font-size: 16px">
                please check your inbox
              </p>
            </div>
            <v-btn @click="goToPage('/')" class="white--text ok-btn">
              Ok
            </v-btn>
          </v-row>
          <v-row> </v-row>
        </v-col>
      </v-dialog>
    </v-col>
    <v-container style="padding: 1%">
      <v-row justify="center" style="padding: 5%">
        <img
          src="../assets/logo.png"
          style="height: 90px"
          alt="Pinme logo"
        />
      </v-row>
      <v-row justify="center" align="center" style="height: 37vh">
        <v-col justify="center" align="center" cols="11" sm="10" md="8" lg="6">
          <div class="password-container">
            <v-row
              xs="12"
              sm="10"
              md="8"
              lg="6"
              justify="center"
              style="font-size: 30px; font-weight: bold; color: #005157"
            >
              Forgot Password
            </v-row>
            <v-form>
              <v-row>
                <v-col>
                  <v-text-field
                    ref="email"
                    v-model="email"
                    dense
                    label="Email Address"
                    rounded
                    outlined
                    class="input"
                    :rules="emailRules"
                  ></v-text-field>
                  <v-btn @click="resetPassword()" class="white--text send-btn">
                    Send
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-row justify="center">
      <v-alert
        v-if="success"
        style="position: absolute; top: 50%"
        type="success"
        >{{ successMessage }}</v-alert
      >
      <v-alert v-if="error" style="position: absolute; top: 50%" type="error">{{
        errorMessage
      }}</v-alert>
    </v-row>
  </div>
</template>

<script>
import { auth } from "../firebaseConfig.js";
import { sendPasswordResetEmail } from "firebase/auth";

export default {
  data() {
    return {
      dialog: false,
      email: "",
      password: "",
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
      error: false,
      success: false,
      errorMessage: "Something went wrong, please try again",
      successMessage: "Success",
    };
  },
  methods: {
    goToPage(path) {
      this.$router.push({ path });
    },
    // Method to send a reset password to the AppUsers
    resetPassword() {
      let emailValid = this.$refs.email.validate();

      if (!emailValid) {
        this.errorMessage = "Please enter a valid email!";

        this.displayErrorMessage();
        return;
      }

      sendPasswordResetEmail(auth, this.email)
        .then((userCredential) => {
          this.dialog = true;
          // Signed in
          // const AppUsers = userCredential.AppUsers;
          // console.log("Email sent res: ", AppUsers);
          //  this.$router.push('users')
        })
        .catch((error) => {
          console.log(error);

          this.errorMessage =
            "Failed to send password reset email, please try again!";

          if (
            error == "FirebaseError: Firebase: Error (auth/AppUsers-not-found)."
          ) {
            this.errorMessage =
              "Email not found , please try a different email address!";
          }

          this.displayErrorMessage();
        });
    },
    // Method to display a popup error message
    displayErrorMessage() {
      let that = this;
      this.error = true;

      setTimeout(function () {
        that.error = false;
      }, 3000);
    },
  },
};
</script>

<style scoped>
.input {
  width: 60%;
  color: #00d200;
  padding: 3%;
}

.container {
  background-color: white;
  width: 100%;
  height: 300px;
  font-size: 18px;
  font-weight: bold;
  padding: 15%;
}

.ok-btn {
  background: rgb(23, 74, 133);
  background: linear-gradient(
    0deg,
    rgba(0,129,128,255) 0%,
    rgba(0,129,128,255) 100%
  );
  border-radius: 20px;
  width: 40%;
  margin-top: -15%;
}

.send-btn {
  background: rgb(23, 74, 133);
  background: linear-gradient(
    0deg,
    rgba(0,129,128,255) 0%,
    rgba(0,129,128,255) 100%
  );
  border-radius: 20px;
  width: 30%;
}

.password-container {
  box-shadow: 1px 2px 5px 2px #b5b5b5;
  border-radius: 9px;
}
</style>
